import Alerts from 'lib/alerts';
import template from '../../templates/dashboard/Employees.ejs';
import content from '../../templates/dashboard/EmployeesContent.ejs';
import row from '../../templates/dashboard/EmployeeRow.ejs';
import Employees from 'newCollections/employees.js';
import loader from 'helpers/loader.js';
import InviteMessage from '../../templates/InviteMessage.ejs';

module.exports = Backbone.View.extend({
    events: {
        'click .js-show-more': 'loadEmployees'
    },

    initialize: function(options) {
        /* FIXME NEVER extend this with the options argument */
        _.extend(this, options);
        this.offset = 0;
        this.limit = 8;
        this.isLoading = false;
        this.employees = new Employees(null, {
            company: app.company,
            pagination: false
        });
        this.render();
        this.loadEmployees();

        return this;
    },

    loadEmployees: function() {
        if (this.isLoading) {
            return false;
        }

        this.isLoading = true;
        this.$('.js-show-more').button('loading');
        return this.employees.fetch({filter: {
            where: {
                hiddenAt: null,
                userId: null
            },
            order: 'fullName ASC',
            offset: this.offset,
            limit: this.limit
        }})
            .then(() => {
                if (this.offset === 0 && this.employees.length <= 0) {
                    this.remove();
                    return true;
                }

                if (this.offset === 0) {
                    Promise.join(
                        this.employees.count({hiddenAt: null}),
                        this.employees.count({
                            hiddenAt: null,
                            userId: null
                        })
                    ).then(([total, inactive]) => {
                        this.renderContent({
                            total:    total || 0,
                            inactive: inactive || 0
                        });

                        this.renderEmployees(this.employees);
                    });
                } else {
                    this.renderEmployees(this.employees);
                }
            })
            .catch(err => { Alerts.show('criticalError', err); })
            .finally(() => {
                this.isLoading = false;
                this.$('.js-show-more').button('reset');
                this.hideLoader();
            });
    },

    renderEmployees: function(employees) {
        employees.each(employee => {
            const $employee = $(row({employee: employee}));
            $employee.find('.js-invite').on('click', ev => {
                ev.preventDefault();
                this.sendInvite(employee, $employee);
            });
            this.$('.js-employees').append($employee);
        });

        this.$('.js-employees-completed').toggleClass(
            'hidden', employees.length !== 0
        );

        this.offset += this.limit;

        this.$('.js-show-more').toggleClass(
            'hidden', employees.length !== this.limit
        );
    },

    sendInvite: function(employee) {
        var stopLoader = loader.startFullScreen(this.$('.btn-invite-employee'));

        return employee.invite().then(() => {
            this.offset = 0;
            this.render();
            this.loadEmployees.apply(this);

            Alerts.show('success', {
                text: InviteMessage()
            });
        }).catch(err => {
            Alerts.show('error', {text: err.message});
        }).finally(stopLoader);
    },

    render: function() {
        this.$el.html(template());
        return this;
    },

    renderContent: function(options) {
        this.$('.js-employees-content').html(content(options));
        this.undelegateEvents();
        this.delegateEvents();
    },

    hideLoader: function() {
        this.$('.js-loader').hide();
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/dashboard/Employees.js